export default {
  install (Vue) {
    window.dataLayer = window.dataLayer || [];

    const gtm = {
      trackEvent (event) {
        window.dataLayer.push(event);
      },
    };

    Vue.prototype.$gtm = gtm;
    Vue.$gtm = gtm;
  },
};
